export default "__VITE_ASSET__BMRNtObP__"